// Supported MIME types for different file categories
export const SUPPORTED_MIMES = {
   IMAGE: ['image/png', 'image/jpeg', 'image/jpg'],
   VIDEO: ['video/mp4', 'video/webm', 'video/quicktime'],
   AUDIO: ['audio/mp3', 'audio/wav', 'audio/mpeg', 'audio/ogg', 'audio/aac', 'audio/vnd.dlna.adts'],
   DOCUMENT: [
      'application/pdf',
      'application/msword',
      'application/vnd.ms-excel',
      'application/vnd.ms-powerpoint',
      'text/plain',
      'text/csv',
      'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
      'application/zip',
      'application/x-zip-compressed',
      'application/rar',
      'application/vnd.rar',
      'application/excel',
      'application/x-excel',
      'application/x-msexcel',
      'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      'application/vnd.openxmlformats-officedocument.presentationml.presentation',
   ],
};

// Supported file extensions
export const SUPPORTED_FILE_EXTENSIONS = {
   IMAGE: ['.png', '.jpeg', '.jpg'],
   VIDEO: ['.mp4'],
   AUDIO: ['.wav', '.mp3', '.aac'],
   DOCUMENT: ['.pdf', '.doc', '.docx', '.xls', '.xlsx', '.txt', '.csv', '.ppt', '.pptx', '.zip', '.rar'],
};

// Media type categories
export const MEDIA_TYPES = {
   IMAGE: 'image',
   VIDEO: 'video',
   AUDIO: 'audio',
   DOCUMENT: 'file',
   FILE: 'file', // Alias for backward compatibility
   IMAGE_VIDEO: 'imagevideo',
};

const removeDot = exts => exts.map(ext => ext.replace('.', ''));

export const ALLOWED_IMAGE_FORMATS = removeDot(SUPPORTED_FILE_EXTENSIONS.IMAGE);
export const ALLOWED_VIDEO_FORMATS = removeDot(SUPPORTED_FILE_EXTENSIONS.VIDEO);
export const ALLOWED_AUDIO_FORMATS = removeDot(SUPPORTED_FILE_EXTENSIONS.AUDIO);
export const ALLOWED_DOCUMENT_FORMATS = removeDot(SUPPORTED_FILE_EXTENSIONS.DOCUMENT);

export const ALLOWED_IMAGE_VIDEO_FORMATS = [...ALLOWED_IMAGE_FORMATS, ...ALLOWED_VIDEO_FORMATS];

export const IMAGE_VIDEO_FORMATS = [...SUPPORTED_MIMES.IMAGE, ...SUPPORTED_MIMES.VIDEO];
export const IMAGE_FORMATS = SUPPORTED_MIMES.IMAGE;
export const AUDIO_FORMATS = SUPPORTED_MIMES.AUDIO;
export const VIDEO_FORMATS = SUPPORTED_MIMES.VIDEO;
export const DOCUMENT_FORMATS = SUPPORTED_MIMES.DOCUMENT;

export const ALLOWED_ALL_FILE_FORMATS = [
   ...ALLOWED_IMAGE_FORMATS,
   ...ALLOWED_VIDEO_FORMATS,
   ...ALLOWED_AUDIO_FORMATS,
   ...ALLOWED_DOCUMENT_FORMATS,
];

export const ACCEPT_TYPES = {
   [MEDIA_TYPES.IMAGE]: '.png,.jpeg,.jpg',
   [MEDIA_TYPES.VIDEO]: '.mp4',
   [MEDIA_TYPES.AUDIO]: '.wav,.mp3,.aac',
   [MEDIA_TYPES.FILE]: '.pdf,.xlsx,.xls,.txt,.doc,.docx,text/plain,.csv,.ppt,.zip,.rar,.pptx',
   [MEDIA_TYPES.IMAGE_VIDEO]: '.mp4,.png,.jpeg,.jpg',
};

export const FEATURE_RESTRICTION_ERROR_MESSAGE = 'Feature unavailable for your plan';

// Media Dimensions
export const MAX_WIDTH_WEB = 330;
export const MIN_WIDTH_WEB = 240;
export const MAX_HEIGHT_WEB = 338;
export const MIN_HEIGHT_WEB = 83;

export const MAX_WIDTH_AND = 250;
export const MIN_WIDTH_AND = 210;
export const MAX_HEIGHT_AND = 320;
export const MIN_HEIGHT_AND = 80;

export const MIN_OFFSET_WIDTH = 280;
export const MIN_OFFSET_HEIGHT = 280;

export const MIN_THUMB_WIDTH = 322;
export const CAPTION_MARGIN = 0;

export const mediaStatusConstants = {
   UPLOADING: 'UPLOADING',
   DOWNLOADING: 'DOWNLOADING',
   LOADED: 'LOADED',
   NOT_DOWNLOADED: 'NOT_DOWNLOADED',
   NOT_UPLOADED: 'NOT_UPLOADED',
   UNKNOWN: 'UNKNOWN',
};

export const RETAKE = 'Retake';

export const UPLOAD_STATUS = {
   PENDING: 0,
   IN_PROGRESS: 1,
   COMPLETED: 2,
   FAILED: 3,
   QUEUED: 8,
};

export const DOWNLOAD_STATUS = {
   NOT_STARTED: 0,
   IN_PROGRESS: 1,
   COMPLETED: 2,
   FAILED: 3,
};
